export default "__VITE_ASSET__mgbKSXHV__"